<template>
    <div
        v-if="isFetch"
        class="main-content"
        :class="{'main-content--wide' : techChatsIds.some(el => el === channelId)}"
    >
        <Loader />
    </div>

    <div
        v-else
        class="main-content"
        :class="{'main-content--wide' : techChatsIds.some(el => el === channelId)}"
    >

        <div class="no-connection" v-show="noConnection">
            <img :src="env.public_base + '/assets/images/wifi-off.svg'" alt="">
        </div>

        <div class="row--header">
            <app-common-header></app-common-header>
        </div>

        <hr class="separator" />

        <app-messages></app-messages>

        <button type="button" class="button-scroll"
                @click="scrollDown"
                ref="scrollButton"
                v-if="mainChat.scrollButton"
                :class="{'button-scroll--full' : techChatButton}"
        >
            <img :src="env.public_base + '/assets/images/button-down-icon.svg'" alt="">
        </button>

        <app-modal-choose-groups v-if="modals.chooseGroups.isActive"
                                 v-click-outside="closeModal"></app-modal-choose-groups>

        <app-message-form v-if="techChatForm && mutedForm"></app-message-form>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Header from '../../common_components/Header.vue';
    import MessageForm from './MessageForm.vue';
    import Messages from './Messages.vue';
    import ModalChooseGroups from './modals/ModalChooseGroups.vue';
    import env from '../../env';
    import vClickOutside from 'v-click-outside';
    import Loader from "../../common_components/Loader";

    export default {
        directives: {
            clickOutside: vClickOutside.directive
        },
        props: {
            isFetch: {
                type: Boolean,
                default: false,
            },
        },
        data: () => ({
            env
        }),
        computed: {
            ...mapGetters([
                'noConnection',
                'channel',
                'getMessagesById',
                'messages',
                'mainChat',
                'channelId',
                'lastMessageId',
                'modals',
                'techChat',
                'techChatsIds',
                'userData'
            ]),
            techChatForm() {
                return this.techChatsIds.some(el => el === this.channelId) ? this.userData.role === 'admin' ||
                    this.userData.role === 'moderator' || this.userData.role === 'teacher' : true
            },
            techChatButton() {
                return this.techChatsIds.some(el => el === this.channelId) ? this.userData.role !== 'admin' &&
                    this.userData.role !== 'moderator' : false
            },
            mutedForm() {
                return this.channel && !((this.userData.role === 'student' || this.userData.role === 'student/billing') && this.channel.disable_to_write) && !(this.userData.is_muted && this.channel.is_group);
            }
        },
        components: {
            appModalChooseGroups: ModalChooseGroups,
            appCommonHeader: Header,
            appMessageForm: MessageForm,
            appMessages: Messages,
            Loader,
        },
        methods: {
            closeModal() {
                this.$store.commit('SET_MODAL_STATE', {modal: 'chooseGroups', prop: 'isActive', value: false});
            },
            scrollDown() {
                let latestId = this.lastMessageId;

                let params = {
                    'channel_id': this.channel.id,
                    'query': {
                        'offset': 0,
                        'limit': 20,
                        'id__lte': latestId,
                        'lang': localStorage.getItem('language')
                    },
                    scroll: 1
                };

                this.$store.dispatch('channel_messages', params);

                const _self = this;
                setTimeout(function() {
                    _self.$store.dispatch('scrollChatSection');
                    _self.$store.commit('SET_FOR_COMPONENT', {page: 'mainChat', field: 'scrollButton', value: false});
                }, 100);

                this.$store.dispatch('setAllMessagesRead', {'channel_id': this.channelId, 'lang': localStorage.getItem('language')}).then(res => {
                }, err => console.log(err, "err"));
            },
        }
    }
</script>

<style>
    .no-connection{
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 1000;
        background-color: #ccc;
        opacity: 0.5;
        text-align: center;
    }

    .no-connection img {
        max-width: 100%;
        max-height: 100%;
    }


</style>
